import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const AuthTokenContext = createContext();

export function AuthTokenProvider({ children }) {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('auth_token');
    if (saved) {
      setToken(saved);
    }
  }, []);

  const setAuthToken = (newToken) => {
    localStorage.setItem('auth_token', newToken);
    setToken(newToken);
  };

  const clearAuthToken = () => {
    localStorage.removeItem('auth_token');
    setToken(null);
  };

  const fetchDevToken = async () => {
    const res = await axios.post(process.env.REACT_APP_AUTH_API_URL);
    const devToken = res.data.result.token;
    setAuthToken(devToken);
  };

  const authAxios = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  authAxios.interceptors.request.use((config) => {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return (
    <AuthTokenContext.Provider
      value={{
        token,
        setAuthToken,
        clearAuthToken,
        fetchDevToken,
        authAxios,
      }}
    >
      {children}
    </AuthTokenContext.Provider>
  );
}

export function useAuthToken() {
  return useContext(AuthTokenContext);
}
